const initialState = { data: [], loading: true };

export const GetAllUOMReducer = (state = initialState, action) => {
  switch (action.type) {
    case "get_all_uom":
      return {
        data: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};
